// OutcomePicker — chips visuales para marcar cómo cerró el trade.
// TP verde, SL rojo, los demás neutros. Si auto-detecta inconsistencia con
// el P&L (ej: marcaste SL pero el P&L es positivo), se podría warning, pero
// por ahora solo registramos la intención del usuario sin validación cross.

import type { ReactElement } from 'react';
import type { TradeOutcome } from '@bini-trading/shared-types';
import { cn } from '../../lib/cn';

interface Props {
  value: TradeOutcome | null;
  onChange: (v: TradeOutcome | null) => void;
}

const OPTIONS: ReadonlyArray<{
  value: TradeOutcome;
  label: string;
  hint: string;
  selectedClass: string;
}> = [
  {
    value: 'tp',
    label: '✓ TP',
    hint: 'Take Profit',
    selectedClass: 'bg-win-DEFAULT/15 border-win-DEFAULT text-win-DEFAULT',
  },
  {
    value: 'sl',
    label: '✕ SL',
    hint: 'Stop Loss',
    selectedClass: 'bg-loss-DEFAULT/15 border-loss-DEFAULT text-loss-DEFAULT',
  },
  {
    value: 'manual',
    label: '✋ Manual',
    hint: 'Cierre por mano',
    selectedClass: 'bg-info-DEFAULT/15 border-info-DEFAULT text-info-DEFAULT',
  },
  {
    value: 'breakeven',
    label: '= BE',
    hint: 'Breakeven',
    selectedClass: 'bg-surface-strong border-ink-muted text-ink',
  },
  {
    value: 'trailing',
    label: '↗ Trail',
    hint: 'Trailing stop',
    selectedClass: 'bg-warn-DEFAULT/15 border-warn-DEFAULT text-warn-DEFAULT',
  },
];

export function OutcomePicker({ value, onChange }: Props): ReactElement {
  return (
    <div className="grid grid-cols-5 gap-2">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          title={opt.hint}
          onClick={() => onChange(value === opt.value ? null : opt.value)}
          className={cn(
            'h-10 rounded-lg border text-xs font-semibold transition-all',
            value === opt.value
              ? opt.selectedClass
              : 'bg-surface-elevated border-surface-border text-ink-muted hover:border-surface-strong hover:text-ink',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
